import { useQuery } from "@tanstack/react-query";
import { useRestClient } from "../../api/RestClientContext";

export const usePayTypes = () => {
    const client = useRestClient();
    
	const query = useQuery({
		queryKey: ['pay-types'],
		queryFn: client.getPayTypes,
		retry: false, 
        staleTime: 60 * 60 * 1000,
        refetchOnWindowFocus: false,
	});

	return {
		payTypes: query.data,
		isLoading: query.isLoading,
		error: query.error,
	};
}